import apiClient from './apiClient';

const customersService = {
  getCustomers: async () => {
    const response = await apiClient.get('/customers');
    // Backend returns {customers: [...], pagination: {...}}
    // Extract and return just the customers array
    return response.data.customers || [];
  },
  
  getMerchantCustomers: async () => {
    // Session-based: uses authenticated user from req.user
    const response = await apiClient.get('/customers');
    // Backend returns {customers: [...], pagination: {...}}
    // Extract and return just the customers array
    return response.data.customers || [];
  },
  
  getCustomer: async (id) => {
    const response = await apiClient.get(`/customers/${id}`);
    return response.data;
  },
  
  getCustomerDetails: async (id) => {
    const response = await apiClient.get(`/customers/details/${id}`);
    return response.data;
  },
  
  createCustomer: async (data) => {
    const response = await apiClient.post('/customers', data);
    return response.data;
  },
  
  updateCustomer: async (id, data) => {
    const response = await apiClient.put(`/customers/${id}`, data);
    return response.data;
  },
  
  deleteCustomer: async (id) => {
    const response = await apiClient.delete(`/customers/${id}`);
    return response.data;
  },
  
  getCustomerArSummary: async (customerId) => {
    const response = await apiClient.get(`/customers/${customerId}/ar-summary`);
    return response.data;
  },
  
  getCustomerBalanceHistory: async (customerId, params = {}) => {
    const response = await apiClient.get(`/customers/${customerId}/balance-history`, { params });
    return response.data;
  },
  
  generatePortalLink: async (customerId) => {
    const response = await apiClient.post('/portal/generate-token', {
      customerId,
      expirationDays: 30
    });
    return response.data;
  },
};

export default customersService;